import { Injectable } from '@angular/core';
import { Job } from '../../domain/job';
import JOB_DESCRIPTION_01 from './content/frontend-developer-description.content.html';
import JOB_DESCRIPTION_02 from './content/backend-developer-description.content.html';
import JOB_DESCRIPTION_03 from './content/qa-engineer-description.content.html';
import JOB_DETAIL_FRONTEND_ENGINEER from './content/frontend-developer-detail.content.html';
import JOB_DETAIL_BACKEND_ENGINEER from './content/backend-developer-detail.content.html';
import JOB_DETAIL_QA_ENGINEER from './content/qa-engineer-detail.content.html';

@Injectable({
  providedIn: 'root'
})
export class JobService {

  constructor() { }

  getJobs() {
    var jobFrontendDev = new Job()
    jobFrontendDev.slug = "frontend-developer"
    jobFrontendDev.name = "Frontend Developer"
    jobFrontendDev.keywords = "Frontend Developer, front-end engineer, software developer"
    jobFrontendDev.description = JOB_DESCRIPTION_01
    jobFrontendDev.details = JOB_DETAIL_FRONTEND_ENGINEER
    jobFrontendDev.photo01 = "images/jobs/newsletter-subscription-01.png"
    jobFrontendDev.locations = ["Rawalpindi, Pakistan", "Tallinn, Estonia", "Berlin, Germany", "Toronto, Canada"]
    jobFrontendDev.timeType = "Fulltime"
    jobFrontendDev.type = "Remote"

    var jobBackendDev = new Job()
    jobBackendDev.slug = "backend-developer"
    jobBackendDev.name = "Backend Developer"
    jobBackendDev.keywords = "Backend Developer"
    jobBackendDev.description = JOB_DESCRIPTION_02
    jobBackendDev.details = JOB_DETAIL_BACKEND_ENGINEER
    jobBackendDev.photo01 = "images/jobs/newsletter-subscription-01.png"
    jobBackendDev.locations = ["Rawalpindi, Pakistan", "Tallinn, Estonia", "Berlin, Germany", "Toronto, Canada"]
    jobBackendDev.timeType = "Fulltime"
    jobBackendDev.type = "Remote"

    var jobQaEngg = new Job()
    jobQaEngg.slug = "newsletter-subscription-management"
    jobQaEngg.name = "QA Engineer"
    jobQaEngg.keywords = "Newsletter, Subscription, email"
    jobQaEngg.description = JOB_DESCRIPTION_03
    jobQaEngg.details = JOB_DETAIL_QA_ENGINEER
    jobQaEngg.photo01 = "images/jobs/newsletter-subscription-01.png"
    jobQaEngg.locations = ["Rawalpindi, Pakistan", "Tallinn, Estonia", "Berlin, Germany", "Toronto, Canada"]
    jobQaEngg.timeType = "Fulltime"
    jobQaEngg.type = "Remote"

    return [jobFrontendDev, jobBackendDev, jobQaEngg]
  }
}
